export default "__VITE_ASSET__D$qtiwPf__"